import localStorageService from 'helpers/localStorageService';
import axiosRequest from './axios';

export const getHeader = <T>(header: T) => {
  const defaultHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Authorization: '',
  };
  const token = localStorageService.get<string>('jwt');
  if (token) defaultHeaders.Authorization = `Bearer ${token}`;
  // Optional tenant override header for admin-scoped views
  const tenantOverride = localStorageService.get<string>('tenantOverride');
  if (tenantOverride) defaultHeaders['x-tenant-id'] = tenantOverride;

  if (header) return { ...defaultHeaders, ...(header as any) };
  return defaultHeaders;
};

type Request<P, D, H> = {
  baseURL?: string;
  method: 'POST' | 'PUT' | 'GET' | 'PATCH' | 'DELETE';
  url: string;
  params?: P;
  data?: D;
  header?: H;
  timeout?: H;
};

const request = <P, D, H>({ baseURL, method, url, params, data, header }: Request<P, D, H>) =>
  axiosRequest({
    baseURL,
    method,
    url,
    params,
    data,
    headers: getHeader(header),
    timeout: url === '/hos/tripHistory' ? 300000 : Number(process.env.REACT_APP_API_REQUEST_TIMEOUT) || 180000,
  });

const httpRequest = {
  request,
};

export default httpRequest;
